import { PORTAL_UI_V2 } from "../../../config/uiTheme";
import SiteDashboardLegacy from "./SiteDashboardLegacy";
import SiteDashboardV2 from "./SiteDashboardV2";

const SiteDashboard = () => (PORTAL_UI_V2 ? <SiteDashboardV2 /> : <SiteDashboardLegacy />);

export default SiteDashboard;
